import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getPhoenixApiTenantUrl,
  modify,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type { ServiceProviderStripeState } from '@pflegenavi/service-provider-shared/api-endpoints';

export interface CreateStripeAccountResponse {
  id: string;
  url: string;
  currently_due: boolean;
  onboarding_started: boolean;
}

export interface IStripePhoenixApi extends Api {
  getServiceProviderStripeState(): Promise<ServiceProviderStripeState>;
  createStripeAccount(dataIn?: {
    body?: unknown;
  }): Promise<CreateStripeAccountResponse>;
  refreshStripeAccount(dataIn?: {
    body?: unknown;
  }): Promise<CreateStripeAccountResponse>;
}

export class StripePhoenixApi implements IStripePhoenixApi {
  getServiceProviderStripeState: IStripePhoenixApi['getServiceProviderStripeState'];
  createStripeAccount: IStripePhoenixApi['createStripeAccount'];
  refreshStripeAccount: IStripePhoenixApi['refreshStripeAccount'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    const baseUrl = getPhoenixApiTenantUrl('service-provider', apiUrl);

    this.getServiceProviderStripeState = get({
      authContext,
      url: `${baseUrl}/stripe/state`,
    });

    this.createStripeAccount = modify({
      authContext,
      method: 'POST',
      url: `${baseUrl}/stripe/account`,
    });

    this.refreshStripeAccount = modify({
      authContext,
      method: 'POST',
      url: `${baseUrl}/stripe/account/refresh`,
    });
  }
}
